import { useEffect, useState } from "react";
import SearchBar from "./SearchBar";
import { TriggerButton, FiltersButton, RefreshButton } from "./TriggerButton";
import FiltersContainer from "./FiltersContainer";
import { getMitigationMeasures } from "./Requests";
import Results from "./Results";

function ValidateResponse(response) {
  console.log("ValidateResponse", response);

  const resultsCategories = [];
  if (!response || !response.status) {
    return null;
  }
  if (!response?.attribute_ranges?.cost) {
    return null;
  }
  console.log("flag-1");

  if (
    response?.long_scale_results &&
    !!Object.keys(response?.long_scale_results?.results).length
  ) {
    resultsCategories.push("long_scale_results");
  }
  if (
    response?.short_scale_results &&
    !!Object.keys(response?.short_scale_results?.results).length
  ) {
    resultsCategories.push("short_scale_results");
  }
  if (
    response?.bibliography_results &&
    !!Object.keys(response?.bibliography_results?.results).length
  ) {
    resultsCategories.push("bibliography_results");
  }
  return resultsCategories;
}

const DSSContainer = () => {
  const [activateTrigger, setActivateTrigger] = useState(false);
  const [activeFilters, setActiveFilters] = useState(false);
  const [activeRefresh, setActiveRefresh] = useState(false);
  const [initSearch, setInitSearch] = useState(false);
  const [requestKeywords, setRequestKeywords] = useState({});
  const [mitigationMeasures, setMitigationMeasures] = useState({});
  const [respondedFilters, setRespondedFilters] = useState({});
  const [requestFilters, setRequestFilters] = useState({
    confidenceThreshold: 5,
    cost: [0, 5],
    areaOfApplication: [0, 5],
    topologicalEffect: [0, 5],
    implementationTimeframe: [0, 5],
  });
  function triggerDSS() {
    if (!activateTrigger || !Object.keys(requestKeywords).length) return;
    console.log("DSS Triggered");

    const requestBody = {
      keywords: requestKeywords,
      filters: requestFilters,
    };
    console.log(requestBody);

    async function sendRequest() {
      const response = await getMitigationMeasures(requestBody);
      const resultsCategories = ValidateResponse(response);
      console.log("Results Categories", resultsCategories);

      if (resultsCategories && resultsCategories.length > 0) {
        setMitigationMeasures(response);
        setRespondedFilters((prevFilters) => ({
          ...prevFilters,
          confidenceThreshold: Math.round(response.confidence_score_ranges.min),
          cost: [
            Math.round(response.attribute_ranges.cost.min) + 1,
            Math.round(response.attribute_ranges.cost.max),
          ],
          areaOfApplication: [
            Math.round(response.attribute_ranges.areaOfApplication.min) + 1,
            Math.round(response.attribute_ranges.areaOfApplication.max),
          ],

          topologicalEffect: [
            Math.round(response.attribute_ranges.topologicalEffect.min) + 1,
            Math.round(response.attribute_ranges.topologicalEffect.max),
          ],
          implementationTimeframe: [
            Math.round(response.attribute_ranges?.implementationTimeframe.min) +
              1,
            Math.round(response.attribute_ranges?.implementationTimeframe.max),
          ],
        }));
      } else {
        console.log("Error");
      }
    }
    sendRequest();
  }

  useEffect(() => {
    triggerDSS();
  }, [requestKeywords, requestFilters]);

  function refreshSearch() {
    setInitSearch(true);
    setActivateTrigger(false);
    setActiveRefresh(false);
  }

  return (
    <div className="dss-page-container">
      <h2 className="dss-header-section">
        {" "}
        TRIQUETRA Mitigation Measure Selection & Optimisation Module
      </h2>
      <section className="dss-search-container">
        <SearchBar
          setActivateTrigger={setActivateTrigger}
          setRequestKeywords={setRequestKeywords}
          setActiveRefresh={setActiveRefresh}
          initSearch={initSearch}
          setInitSearch={setInitSearch}
        />
        <div className="dss-search-btns">
          <TriggerButton active={activateTrigger} triggerDSS={triggerDSS} />
          {activeRefresh && (
            <RefreshButton
              active={activeRefresh}
              refreshSearch={refreshSearch}
            />
          )}
        </div>
      </section>
      {!!Object.keys(mitigationMeasures).length && (
        <>
          <section
            className={
              "dss-filters-container" + (activeFilters ? " active" : "")
            }
          >
            <FiltersButton
              active={activeFilters}
              displayFilters={setActiveFilters}
            />
            {activeFilters && (
              <FiltersContainer
                values={
                  !!Object.keys(respondedFilters).length
                    ? respondedFilters
                    : requestFilters
                }
                setRequestFilters={setRequestFilters}
              />
            )}
          </section>
          <Results results={mitigationMeasures} />
        </>
      )}
    </div>
  );
};

export default DSSContainer;
